var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-4 text-sm"},[_c('router-link',{staticClass:"hover:underline underline-offset-1",attrs:{"to":_vm.to}},[_vm._v("\n    < Back to "+_vm._s(_vm.title)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }